const zhCN = {
  // ChatWidget
  "chat.welcome.title": "OceanMCP",
  "chat.welcome.description": "浏览器协同 AI 助手，可以读取页面数据、执行操作、自动化工作流。",
  "chat.welcome.suggestion1": "这个页面有什么？",
  "chat.welcome.suggestion2": "展示页面信息",
  "chat.welcome.suggestion3": "你能做什么？",
  "chat.input.placeholder": "输入消息...",
  "chat.upload.title": "上传文件",
  "chat.upload.uploading": "上传中...",
  "chat.upload.remove": "移除",
  "chat.dragdrop.title": "拖放文件到这里",
  "chat.dragdrop.description": "松开鼠标即可上传",
  "chat.error.label": "错误：",
  "chat.stop.title": "停止生成",
  "chat.command.new": "创建并切换到新会话",
  "chat.command.sessions": "查看并切换历史会话",
  "chat.session.open": "会话历史",
  "chat.session.title": "历史会话",
  "chat.session.description": "切换、删除或创建新的会话",
  "chat.session.new": "新建会话",
  "chat.session.close": "关闭",
  "chat.session.empty": "暂无历史会话",
  "chat.session.untitled": "未命名会话",
  "chat.session.updatedAt": "最近更新：{time}",
  "chat.session.delete": "删除",
  "chat.session.deleteConfirm": "确认删除这个会话吗？",

  // MessageRenderer
  "tool.status.complete": "已完成",
  "tool.status.error": "错误",
  "tool.status.running": "执行中",
  "tool.status.denied": "已拒绝",
  "tool.inline.running": "调用 {name}...",
  "tool.inline.complete": "已调用 {name}",
  "tool.inline.error": "调用 {name} 失败",
  "tool.inline.denied": "调用 {name} 已拒绝",
  "tool.label.result": "执行结果",
  "tool.label.parameters": "参数",
  "tool.renderError": "渲染异常：",
  "copy.title": "复制",

  // MessageReasoning
  "reasoning.loading": "思考中...",
  "reasoning.title": "思考过程",
  "thinking.running": "思考中...",
  "thinking.done": "思考完成",
  "thinking.stopped": "思考已停止",
  "thinking.error": "思考完成（含错误）",
  "thinking.callingTool": "调用工具 {name}...",
  "thinking.loadingSkill": "加载技能 {name}...",

  // FlowNodeCard
  "flow.title": "执行计划",
  "flow.stepCount": "{count} 个步骤",
  "flow.approve": "允许",
  "flow.deny": "拒绝",
  "flow.showMore": "展开剩余 {count} 行",
  "flow.collapse": "收起",
  "flow.itemCount": "{count} 项",
  "flow.rawData": "原始数据",
  "flow.showError": "展开详情",
  "flow.hideError": "收起",

  // ApprovalButtons
  "approval.status": "待确认",
  "approval.parameters": "参数",
  "approval.allow": "允许",
  "approval.deny": "拒绝",

  // AskUserCard
  "askUser.title": "请填写",
  "askUser.status.complete": "已完成",
  "askUser.status.error": "错误",
  "askUser.status.pending": "待填写",
  "askUser.status.denied": "已取消",
  "askUser.submitted": "已提交",
  "askUser.value": "值：",
  "askUser.failed": "提交失败。",
  "askUser.prompt": "请提供以下信息：",
  "askUser.confirm": "提交",
  "askUser.deny": "取消",
  "askUser.deniedMessage": "已取消填写。",
  "askUser.required": "必填",
  "askUser.selectPlaceholder": "请选择",
  "askUser.inputPlaceholder": "请输入",

  // SubagentCard
  "subagent.title": "子任务",
  "subagent.status.running": "执行中...",
  "subagent.status.complete": "已完成",
  "subagent.status.error": "执行失败",
  "subagent.status.timeout": "执行超时",
  "subagent.systemPrompt": "系统提示词",
  "subagent.modelOutput": "模型输出（返回给主智能体）",
};

export default zhCN;
